<template>
<div>
    <button @click="handleButton" type='button' class='btn-audio'><i class='icon'></i></button>
    <div class="audio-player">
        <div class="player none">
            <div class='cover-player'>
            <div id='keterangan'>
                <h4 id='nama-surat'>{{namaAyat}}</h4>
                <label for='#nama-surat'>{{ artiAyat }}</label>
                <!-- range input -->
                <div id='seek-bar'>
                    <small id='dari'>{{from}}</small>
                    <input type='range' min='0' max="100" value="24" id='seek'/>
                    <small id='ke'>{{to}}</small>
                </div>
                <!-- akhir range input -->
                <div id='tombol-player'>
                    <button @click="arr -= 1; handlePrev()" class="btn-player prev" type='button'><i class="fa fa-chevron-left"></i></button>
                    <button @click="handlePlay()" class='btn-player2' type='button'>
                        <span id='icon-play'><i class='fa fa-play'></i></span>
                        <span style="display: none;" id='icon-pause'><i class='fa fa-pause'></i></span>
                    </button>
                    <button @click='arr += 1; handleNext()' class="btn-player right" type='button'><i class="fa fa-chevron-right"></i></button>
                    <audio id='audio'>
                        <source v-bind:src="audio" type='audio/mp3'>
                    </audio>
                </div>
                <!-- button untuk keluar di tampilan mobile -->
                <center>
                <button type='button' @click="handleOut" class='btn-out'>Kembali</button>
                </center>
                <!-- akhir button -->
            </div>
        </div>
        </div>
    </div>
</div>
</template>
<style scoped>
    .putar 
    {
        animation: rotate 4s ease forwards;
    }
    @keyframes rotate 
    {
        from 
        {
            transform: rotate(0deg);
        }
        to 
        {
            transform: rotate(360deg);
        }
    }
    .btn-out 
    {
        width: 80%;
        height: 35px;
        border-radius: 50px;
        margin-top: 10%;
        border: 1px solid #5ef34a;
        background-color: #5ef34a;
        color: white;
        transition: 0.4s;
        display: none;
    }
    .btn-out:hover{
        box-shadow: 0px 6px 20px 0.1px #5ef34a;
    }
    .btn-out:focus{
        outline: none;
    }
    #tombol-player 
    {
        margin-top: 12%;
    }
    #tombol-player small 
    {
        font-size: 11px;
    }
    .btn-player2
    {
        width: 45px;
        height: 45px;
        border-radius: 50px;
        border: 1.5px solid #5ef34a;
        background-color: transparent;
        color: #5ef34a;
        margin: 0% 5% 0% 5%;
        transition: 0.3s;
    }
    .btn-player2:hover{
        background-color: #5ef34a;
        color: white;
    }
    .btn-player2:focus{
        outline: none;
    }
    .btn-player{
        background-color: transparent;
        border: none;
        color: #5ef34a;
    }
    .btn-player:focus{
        outline: none;
    }
    #seek
    {
        width: 50%;
        -webkit-appearance: none;
        height: 5px;
        background-color: #ebebeb;
        border-radius: 50px;
    }
    #seek:focus{
        outline: none;
    }
    #seek::-ms-track
    {
        width: 100%;
        cursor: pointer;
        background: transparent;
        border: transparent;
        color: transparent;
    }
    /* styling thumb */
    #seek::-webkit-slider-thumb
    {
        -webkit-appearance: none;
        width: 15px;
        height: 15px;
        border: 1px solid #5ef34a;
        background-color: #5ef34a;
        border-radius: 50px;
        box-shadow: 0px 0px 15px 3px #5ef34a;
        transition: 0.3s;
    }
    #seek::-webkit-slider-thumb:hover{
        box-shadow: 0px 0px 15px 6px #5ef34a;
        cursor: pointer;
    }
    /*  untuk mozila */
    #seek::-moz-range-thumb
    {
        -webkit-appearance: none;
        width: 15px;
        height: 15px;
        border: 1px solid #5ef34a;
        background-color: #5ef34a;
        border-radius: 50px;
        box-shadow: 0px 0px 15px 3px #5ef34a;
        transition: 0.3s;
    }
    #seek::-moz-range-thumb:hover{
        box-shadow: 0px 0px 15px 6px #5ef34a;
        cursor: pointer;
    }
    /* IE */
    #seek::-ms-thumb
    {
        -webkit-appearance: none;
        width: 15px;
        height: 15px;
        border: 1px solid #5ef34a;
        background-color: #5ef34a;
        border-radius: 50px;
        box-shadow: 0px 0px 15px 3px #5ef34a;
        transition: 0.3s;
    }
    #seek::-ms-thumb:hover{
        box-shadow: 0px 0px 15px 6px #5ef34a;
        cursor: pointer;
    }
    #seek-bar 
    {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 15%;
        
    }
    .player 
    {
        width: 100%;
        height: auto;
        background-color: white;
        padding: 20% 4% 20% 4%;
        display: block;
        border-radius: 5px;
        box-shadow: 0px 6px 40px 0.1px rgba(0,0,0,0.2);
    }
    .audio-player 
    {
        width: 20%;
        height: auto;
        position: fixed;
        z-index: 500;
        right: 2%;
        bottom : 25%;
        text-align: center;
    }
    .btn-audio 
    {
        width: 50px;
        height: 50px;
        border-radius: 50px;
        border: 1px solid #5ef34a;
        background-color: #5ef34a;
        color: white;
        box-shadow: 0px 0px 15px 2px #5ef34a;
        transition: 0.3s;
        position: fixed;
        right: 3%;
        bottom: 8%;
    }
    .btn-audio:hover{
        box-shadow: 0px 0px 20px 3px #5ef34a;
    }
    .btn-audio:focus{
        outline: none;
        box-shadow: 0px 0px 30px 5px #5ef34a;
    }
    .none 
    {
        display: none;
    }
    @media screen and (max-width: 780px)
    {
        .btn-audio
        {
            bottom : 15%;
        }
        .audio-player
        {
            width: 100%;
            height: 100%;
            bottom : 0;
            z-index: 4000;
            transition: 0.3s;
            right: -200%;
        }
        .show-audio
        {
            right: 0;
        }
        .none 
        {
            right: -200%;
        }
        .player
        {
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
        }
        .cover-player 
        {
            width: 90%;
        }
        .btn-out
        {
            height: 45px;
            margin-top: 15%;
            display: block;
        }
        #tombol-player 
        {
            margin-top: 15%;
        }
        .btn-player2
        {
            margin: 0% 8% 0% 8%;
        }
        #seek 
        {
            width: 55%;
        }

    }

</style>
<script>
import { bus } from '../main.js';
import axios from 'axios';


    export default {
        props: {
            data: Array,
        },
        data(){
            return {
                iconPlayer: 'fa fa-play',
                toggle: 0,
                arr: -1,
                namaAyat: 'loading..',
                artiAyat: 'loading..',
                audio : '',
                test: [],
                proxy: 'https://cors-anywhere.herokuapp.com/',
                click: 0,
                from: '00:00',
                to: '00:00',
            }
        },
        created(){
            const alamat = 'https://al-quran-8d642.firebaseio.com/data.json?print=pretty';
            const that = this;
            bus.$on('AddData', function(param){
                axios.get(`${that.proxy}${alamat}`)
                .then( res => {
                    const result = [];
                    const hasil = res.data;
                    result[0] = {};
                    that.namaAyat = hasil[param - 1].nama;
                    that.audio = hasil[param - 1].audio;
                    that.artiAyat = hasil[param - 1].arti;
                }).then(() => {
                    that.play();
                    that.click = 1;
                })
            });
            setTimeout(() => {
             
                this.namaAyat = this.data[0].nama;
                this.artiAyat = this.data[0].arti;
                this.audio = this.data[0].audio;
                console.log(this.data.length);
            }, 3000);
        },
        mounted(){

            document.getElementById('seek').oninput = function (){
                this.style.background = 'linear-gradient(to right,  #5ef34a 0%,  #5ef34a '+this.value +'%, #ebebeb ' + this.value + '%, #ebebeb 100%)'
            }
            // handeling button
            document.querySelector('.icon').classList.add('fab');
            document.querySelector('.icon').classList.add('fa-creative-commons-sampling');

            // handling audio

            const audio = document.querySelector('#audio');
            const seek = document.getElementById('seek');
            const dari = document.querySelector('#dari');
            const ke = document.querySelector('#ke');


            setTimeout(() => {
                audio.load();
            },4000)
            
            audio.addEventListener('timeupdate', () => {
                let nilai = (100 / audio.duration) * audio.currentTime;
                seek.value = nilai;

                let from = parseInt(audio.currentTime % 60);
                let fromM = parseInt(audio.currentTime / 60, 10);
                let minutess = parseInt(audio.currentTime / 60, 10);
                let fromH = parseInt(minutess / 60);
                if( fromM > 60 )
                {
                    fromM = parseInt((audio.currentTime / 60, 10) % 60);
                }
                this.from = fromH + ' : ' + fromM +" : "+from;
                const ke = document.querySelector('#ke');
                this.to = this.getDuration();

                if(nilai > 99)
                {
                    this.berhenti();
                    this.click = 0;
                }
            });
            seek.addEventListener('change', () => {
                let val = audio.duration * (seek.value / 100);
                audio.currentTime = val;
                this.style.background = 'linear-gradient(to right,  #5ef34a 0%,  #5ef34a '+this.value +'%, #ebebeb ' + this.value + '%, #ebebeb 100%)'

            });


            ////

        },

        methods: {
            handleButton: function(){

                const ikon = document.querySelector('.icon');
                const places = document.querySelector('.player');
                const audioplayer = document.querySelector('.audio-player');

                if( this.toggle === 0)
                {
                    ikon.classList.add('fa');
                    ikon.classList.add('fa-times');
                    this.toggle = 1;
                    places.classList.remove('none');
                    audioplayer.classList.add('show-audio');
                }else{
                    ikon.classList.remove('fa');
                    ikon.classList.remove('fa-times');
                    ikon.classList.add('fab');
                    ikon.classList.add('fa-creative-commons-sampling');
                    this.toggle = 0;
                    places.classList.add('none');
                    audioplayer.classList.remove('show-audio');
                }

            },
            handleOut: function(){
                const audioplayer = document.querySelector('.audio-player');
                document.querySelector('.player').classList.add('none');
                const ikon = document.querySelector('.icon');
                ikon.classList.remove('fa');
                ikon.classList.remove('fa-times');
                ikon.classList.add('fab');
                ikon.classList.add('fa-creative-commons-sampling');
                audioplayer.classList.remove('show-audio');
                this.toggle = 0;
            },
            handlePrev()
            {
                const audio = document.querySelector('#audio');
                if( this.arr < 0 )
                {
                    this.arr = 0;
                }else{
                    this.namaAyat = this.data[this.arr].nama;
                    this.artiAyat = this.data[this.arr].arti;
                    this.audio = this.data[this.arr].audio;
                    audio.load();
                    this.main();
                }
            },
            handleNext()
            {
                const audio = document.querySelector('#audio');
                if( this.arr > this.data.length - 1)
                {
                    this.arr = this.data.length;
                }else{

                    this.namaAyat = this.data[this.arr].nama;
                    this.artiAyat = this.data[this.arr].arti;
                    this.audio = this.data[this.arr].audio;
                    audio.load();
                    this.main();

                }
            },
            getDuration(){
                const audio = document.querySelector('#audio');
                let ked = parseInt(audio.duration % 60);
                let keM = parseInt(audio.duration / 60, 10);
                let minutes = parseInt(audio.duration / 60, 10);
                if( keM > 60 )
                {
                    keM = parseInt((audio.duration / 60, 10) % 60);
                    if( parseInt((audio.duration / 60, 10) % 60) < 10 )
                    {
                        keM = '0' + parseInt((audio.duration / 60, 10) % 60);
                    }
                }
                let keH = parseInt(minutes / 60);
                return keH + ':' + keM +" : "+ ked;
            },
            main(){
                const audio = document.querySelector('#audio');
                const dari = document.querySelector('#dari');
                const ke = document.querySelector('#ke');
                const iPlay = document.querySelector('#icon-play');
                const iPause = document.querySelector('#icon-pause');

                iPlay.style.display = "none";
                iPause.style.display = "block";
                this.to = this.getDuration();
                audio.play();
            },
            play(){
                const audio = document.querySelector('#audio');
                const dari = document.querySelector('#dari');
                const ke = document.querySelector('#ke');
                const iPlay = document.querySelector('#icon-play');
                const iPause = document.querySelector('#icon-pause');

                iPlay.style.display = "none";
                iPause.style.display = "block";
                this.to =  this.getDuration();
                audio.load();
                audio.play()
            },
            berhenti(){
                const iPlay = document.querySelector('#icon-play');
                const iPause = document.querySelector('#icon-pause');

                iPlay.style.display = "block";
                iPause.style.display = "none";
            },
            handlePlay(){
                const audio = document.querySelector('#audio');
                if( audio.paused === true )
                {
                    if( this.click < 1)
                    {
                        audio.load();
                        this.main();
                        audio.play();
                        this.click = 1;
                    }else{
                        this.main();
                        audio.play();
                    }

                }else{

                    audio.pause();
                    this.berhenti();
                }
            },
        },
    }
</script>